import { AxiosResponse } from 'axios'
import api from 'services/api'
import {
  NDPayload,
  NDResponseType,
  QueryType,
  JustificationNDResponse,
  JustificationVeredict,
  ResponseNDVeredict
} from './interface'
import { env } from 'constants/env'

export const downloadPlanilhaND = async (payload: NDPayload) => {
  const response: AxiosResponse<ArrayBuffer> = await api.post(
    '/gerir-ov/negociacao_diferenciada/exportar',
    payload,
    { responseType: 'arraybuffer' }
  )
  return response
}

export const NDFilter = async (payload: NDPayload, query: QueryType) => {
  return api.post<NDResponseType>(
    `gerir-ov/negociacao-diferenciada/listar?Paginas=${query.page}&Linhas=${query.limit}`,
    payload
  )
}

export const getJustificationND = async (ovNumber: string) => {
  const response = await api.get<JustificationNDResponse[]>(
    `${env.manageOVBasePath}/${ovNumber}/obter-dados-justificativa-negociacao-diferenciada`
  )

  return response.data
}

export const EmptyNDPayload = {
  material: '',
  hierarquiaCliente: false,
  codigosEquipeVenda: [],
  codigosRegiaoVenda: [],
  codigosSapCliente: [],
  razoesSociaisCliente: [],
  numerosOrdemVenda: [],
  numerosOrdemVendaSap: [],
  tiposMaterial: [],
  tiposOrdemVenda: [],
  mesesCota: [],
  causas: [],
  statusAprovacao: []
}

export const getNDList = async (payload: NDPayload, query: QueryType) => {
  const response = await api.post(
    `${env.manageOVBasePath}/negociacao-diferenciada/listar?Paginas=${
      query.page
    }&Linhas=${query.limit}&parametroOrdenacao=${query.column || ''}&ordenarCrescente=${
      query.isCrescent || false
    }`,
    payload !== ({} as NDPayload) ? payload : EmptyNDPayload
  )

  return response.data
}

export const setJustificationVeredict = async (body: JustificationVeredict) => {
  const response = await api.post<ResponseNDVeredict[]>(
    `${env.manageOVBasePath}/negociacao-diferenciada/analisar`,
    body
  )

  return response.data
}

export const getListaAnoMesCota = async () => {
  const response = await api.get(
    `${env.commercialStructure}/${env.apiVersion}/ListaAnoMesCota`
  )

  return response.data.Result
}
